import React, { useState, useRef } from 'react';

const HourAwardsTooltip = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const triggerRef = useRef(null);

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <div 
      ref={triggerRef} 
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isVisible && (
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '8px',
            backgroundColor: '#1D4E89',
            color: 'white',
            padding: '0.75rem 1rem',
            borderRadius: '6px',
            fontSize: '0.875rem',
            maxWidth: '280px',
            minWidth: '200px',
            width: 'auto',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            lineHeight: '1.4',
            border: '2px solid #fff',
            animation: 'fadeIn 0.2s ease-in-out',
            pointerEvents: 'none'
          }}
        >
          <div style={{ marginBottom: '0.5rem' }}>
            Set how many awards user will get for Theory, Field Experience, Capstone, Concentration, and Lab.
          </div>
          <div
            style={{
              position: 'absolute',
              width: 0,
              height: 0,
              border: '6px solid transparent',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderTopColor: '#1D4E89'
            }}
          />
          <style jsx>{`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(-10px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}</style>
        </div>
      )}
    </div>
  );
};

export default HourAwardsTooltip;
